import { useState, useCallback } from 'react';
import dayjs from 'dayjs';

const presetDefs = [
  { key: '24h', n: 1, unit: 'day', text: 'Last 24 hours' },
  { key: '2d', n: 2, unit: 'day', text: 'Last 2 days' },
  { key: '4d', n: 4, unit: 'day', text: 'Last 4 days' },
  { key: '1w', n: 7, unit: 'day', text: 'Last 1 week' },
  { key: 'custom', text: 'Custom range' }
];

export function useDateRange(setRange) {
  const [showCustom, setShowCustom] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState('Last 24 hours');
  const [selectedPreset, setSelectedPreset] = useState('24h');

  const setPreset = useCallback((key) => {
    const preset = presetDefs.find(p => p.key === key);
    if (!preset) return;
    setSelectedPreset(key);

    if (key === 'custom') {
      setShowCustom(true);
      setSelectedLabel('Custom range');
      // El rango custom lo toca el usuario, no lo actualizamos aquí
    } else {
      const now = dayjs();
      const from = now.subtract(preset.n, preset.unit);
      const to = now;
      setShowCustom(false);
      setSelectedLabel(preset.text);
      setRange({ from, to }); // Actualiza el rango controlado en el padre
    }
  }, [setRange]);

  return {
    showCustom,
    selectedLabel,
    setShowCustom,
    setPreset,
    selectedPreset,
    presetDefs,
  };
}
